<template>
  <div class="container-table">
    <q-card-section>
      <q-table
        data-cy="indices-table"
        :title=title
        :title-class=titleclass
        :data="indicesTematicos"
        :columns="columns"
        row-key="id"
        :selection="selectionFormat"
        :pagination.sync="pagination"
        :loading="isLoading"
        :selected.sync="selected"
        :visible-columns="visibleColumns"
      >
        <!-- columna Visible -->
        <template v-slot:body-cell-estado="props">
          <q-td
            @input="changeVisibility(props)"
            data-cy="estadoIndice"
            :props="props"
            key="estado"
          >
            {{props.selected?'Visible':''}}
          </q-td>
        </template>
        <!-- Avatar y Nombre -->
        <template v-slot:body-cell-name="props">
          <q-td key="name" :props="props">
            <q-btn class="imgBtn" round style="cursor:auto">
              <q-avatar size="42px">
                <img :src="props.row.file.length > 0 ? props.row.file[0].url : require(`@/assets/${imgDefault}`)">
              </q-avatar>
            </q-btn>
              {{ props.row.name }}
          </q-td>
        </template>
        <!-- Orden -->
        <template v-slot:body-cell-orden="props">
          <q-td key="order" :props="props">
            {{ props.row.order }}
          </q-td>
        </template>
        <!-- Icono Editar -->
        <template v-slot:body-cell-editar="props">
          <q-td key="editar" :props="props">
            <q-icon
              data-cy="bEditIndiceTematico"
              name="o_create"
              style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
              @click="triggerEdit(props.row)"
            />
          </q-td>
        </template>
        <!-- Icono Eliminar -->
        <template v-slot:body-cell-eliminar="props">
          <q-td key="eliminar" :props="props">
            <q-icon
              data-cy="bDeleteIndiceTematico"
              name="o_delete"
              style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
              @click="triggerDelete(props.row)"
            />
          </q-td>
        </template>
        <!-- Configuración checkbox head tabla -->
        <template v-slot:header-selection="props">
          <q-checkbox
            color="primary"
            v-model="props.selected"
            @input="changeVisibility()"
          />
        </template>
        <!-- Configuración checkbox body tabla -->
        <template v-slot:body-selection="props">
          <q-checkbox
            data-cy="checkBoxIndice"
            color="primary"
            v-model="props.selected"
            @input="changeVisibility(props.row)"
          />
        </template>
      </q-table>
    </q-card-section>
    <!-- Ventana diálogo confirmación de Eliminar -->
    <DialogDelete
      v-if="rowSelectedtoDelete"
      v-model="showDialogDelete"
      dataCy="delete-indice-tematico"
      :showIcon="true"
      :txtContainer="`¿Está seguro de eliminar el índice temático? ${rowSelectedtoDelete.name}`"
      @save="deleteIndiceTematico()"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as types from '@/storeModules/NGUD/types';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import Loading from '@/components/shared/mixins/Loading.js';

import {
  QCheckbox,
  QTable,
  QTd,
  QCardSection,
  QAvatar
} from 'quasar';

export default {
  components: {
    QCheckbox,
    QTable,
    QTd,
    QCardSection,
    QAvatar,
    DialogDelete
  },
  props: {
    isLoading: Boolean,
    indicesTematicosCiudad: Array,
    visibleColumns: Array,
    selectionFormat: String,
    title: {
      required: false,
      type: String,
      default: () => ''
    },
    titleclass: {
      required: false,
      type: String,
      default: () => 'titleCard'
    },
    imgDefault: {
      type: String,
      default: function () {
        return 'img/iconfinder-icon-image.png';
      }
    }
  },
  mixins: [Loading],
  data () {
    return {
      pagination: {
        rowsPerPage: 20
      },
      selected: [],
      executionTimeOut: null,
      isSearch: false,
      showDialogDelete: false,
      rowSelectedtoDelete: null,
      columns: [
        {
          name: 'estado',
          label: 'Estado',
          align: 'left',
          field: 'visible',
          sortable: false
        },
        {
          name: 'name',
          label: 'Nombre',
          align: 'left',
          field: 'name',
          sortable: true,
          sort: (a, b) => b.localeCompare(a)
        },
        {
          name: 'order',
          label: 'Orden',
          align: 'center',
          field: 'order',
          sortable: true
        },
        {
          name: 'editar',
          label: 'Editar',
          align: 'center',
          field: '',
          sortable: false
        },
        {
          name: 'eliminar',
          label: 'Eliminar',
          align: 'center',
          field: '',
          sortable: false
        }
      ]
    };
  },
  created () {
    if (
      this.indicesTematicosCiudad !== null &&
      this.indicesTematicosCiudad !== undefined &&
      Object.entries(this.indicesTematicosCiudad).length > 0
    ) {
      this.selected = this.indicesTematicosCiudad.map((n) => {
        return { id: n };
      });
    }
  },
  computed: {
    ...mapGetters({
      indicesTematicos: types.ALL_INDICES_TEMATICOS
    })
  },
  watch: {
    indicesTematicosCiudad () {
      this.selected = this.indicesTematicosCiudad.map((n) => {
        return { id: n };
      });
    }
  },
  methods: {
    triggerEdit (row) {
      let id = row.id;
      this.$router.push({ name: 'form_edit_indice_tematico', params: { idIndiceTematico: id } });
    },
    triggerDelete (row) {
      this.rowSelectedtoDelete = row;
      this.showDialogDelete = true;
    },
    deleteIndiceTematico () {
      // obtenemos indice
      const index = this.indicesTematicos.indexOf(this.rowSelectedtoDelete);
      // copia del objeto del array
      let newIndicesTematicos = Object.assign([], this.indicesTematicos);
      // eliminamos el elemento
      newIndicesTematicos.splice(index, 1);
      this.$store.dispatch(types.ACTION_DELETE_INDICE_TEMATICO, {
        idIndiceTematico: this.rowSelectedtoDelete.id,
        items: newIndicesTematicos
      })
        .then(response => {
          this.showDialogDelete = false;
          this.hideLoading();
          this.isLoadingDirect = false;
        })
        .catch(() => { this.hideLoading(); this.isLoadingDirect = false; });
    },
    changeVisibility () {
      if (this.isSearch) clearTimeout(this.executionTimeOut);
      this.isSearch = true;
      this.$eventHub.$emit(
        'viewEditedIndexTematicos',
        this.selected.length <= 0 ? [] : this.selected.map(e => e.id)
      );
      this.executionTimeOut = setTimeout(() => {
        this.isSearch = false;
        this.$emit('refreshIndicadores', {
          selected:
            this.selected.length <= 0 ? [] : this.selected.map(e => e.id)
        });
      }, 830);
    }
  }
};
</script>

<style lang="scss" scoped>
button.q-btn.imgBtn {
  margin-left: 0px !important;
  margin-right: 15px;
}
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }
    .q-card__section--vert {
      padding: 0 !important;
    }
    .titleCardEdicion{
      margin: 10px 282px 0px 15px;
      font-family: DINPro;
      font-weight: 500;
      font-size: 20px;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.29px;
      color: #474848;
    }
  }
}
button.q-btn.imgBtn {
  margin-left: 0px !important;
  margin-right: 15px;
}
</style>
